import { render, staticRenderFns } from "./AttachmentsCuota.vue?vue&type=template&id=404ad2a5&scoped=true&"
import script from "./AttachmentsCuota.vue?vue&type=script&lang=js&"
export * from "./AttachmentsCuota.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsCuota.vue?vue&type=style&index=0&id=404ad2a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ad2a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
